var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71428 12.8572L2.57143 12.8572L2.57143 2.57153L18 2.57153V9.57525",
    stroke: "#FFF",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1429 12V15.4286C11.1429 16.8489 13.4451 18 16.2857 18C19.1263 18 21.4286 16.8489 21.4286 15.4286V12",
    stroke: "#FFF",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1429 15.4285V18.857C11.1429 20.2773 13.4451 21.4285 16.2857 21.4285C19.1263 21.4285 21.4286 20.2773 21.4286 18.857V15.4285",
    stroke: "#FFF",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2857 14.5713C19.126 14.5713 21.4286 13.4201 21.4286 11.9999C21.4286 10.5797 19.126 9.42847 16.2857 9.42847C13.4454 9.42847 11.1429 10.5797 11.1429 11.9999C11.1429 13.4201 13.4454 14.5713 16.2857 14.5713Z",
    stroke: "#FFF",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 8.57146C10.7591 8.57146 11.1429 8.18771 11.1429 7.71432C11.1429 7.24093 10.7591 6.85718 10.2857 6.85718C9.81233 6.85718 9.42857 7.24093 9.42857 7.71432C9.42857 8.18771 9.81233 8.57146 10.2857 8.57146Z",
    stroke: "#FFF",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2857 8.57146C10.7591 8.57146 11.1429 8.18771 11.1429 7.71432C11.1429 7.24093 10.7591 6.85718 10.2857 6.85718C9.81233 6.85718 9.42857 7.24093 9.42857 7.71432C9.42857 8.18771 9.81233 8.57146 10.2857 8.57146Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.b3030efcdda830b159e17e0f415e876b.svg";
export { ForwardRef as ReactComponent };